import { normalizeIngredientName } from '../ingredients/normalize-name.js';
// Longer phrases are tried first, so "danke das wars" wins over "das wars". Apostrophes are
// removed before the comparison: "das war's" is listed as "das wars".
const COMMAND_WORDS = {
    de: {
        finish: [
            'danke das wars',
            'das ist alles',
            'das wars',
            'hör auf',
            'aufhören',
            'fertig',
            'stopp',
            'stop',
            'ende',
        ],
        cancel: ['vergiss es', 'abbrechen', 'abbruch', 'verwerfen'],
    },
    en: {
        finish: ['thats all', 'thats it', 'finished', 'done', 'stop', 'end'],
        cancel: ['never mind', 'nevermind', 'discard', 'cancel'],
    },
};
const APOSTROPHES = /['’´`]/g;
const TRAILING_PUNCTUATION = /[\s.,;:!?…]+$/u;
// What may stand between the last item and the command: "… und stopp", "…, äh, abbrechen".
const TRAILING_FILLER = /(?:^|[\s,;.])(?:und dann|and then|und|and|dann|then|okay|ok|so|äh|ähm|öhm|hm+|uh|um)$/iu;
const PART_SEPARATOR = /(?:^|[,;.]|\s(?:und|and|dann|then|plus|sowie))\s*$/iu;
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function stripTrailingFillers(value) {
    let text = value.replace(TRAILING_PUNCTUATION, '');
    for (;;) {
        const match = TRAILING_FILLER.exec(text);
        if (!match)
            return text;
        text = text.slice(0, match.index).replace(TRAILING_PUNCTUATION, '');
    }
}
export function detectDictationEnd(transcript, locale, options = {}) {
    const original = transcript.trim();
    const words = COMMAND_WORDS[locale] ?? COMMAND_WORDS.en;
    // Same length as the original, so an index found here cuts the original at the same place.
    const comparable = original.replace(APOSTROPHES, ' ').toLowerCase();
    const end = comparable.replace(TRAILING_PUNCTUATION, '');
    const known = new Set((options.knownNames ?? []).map((name) => normalizeIngredientName(name)));
    const candidates = [
        ...words.cancel.map((phrase) => ({ action: 'cancel', phrase })),
        ...words.finish.map((phrase) => ({ action: 'finish', phrase })),
    ].sort((a, b) => b.phrase.length - a.phrase.length);
    for (const { action, phrase } of candidates) {
        // "das wars" also matches "das war s" (the apostrophe became a space above).
        const pattern = escapeRegExp(phrase)
            .replace(/wars$/, 'war\\s?s')
            .replace(/^thats/, 'that\\s?s')
            .replace(/ /g, '\\s+');
        const match = new RegExp(`(?<![\\p{L}\\p{N}])${pattern}$`, 'u').exec(end);
        if (!match)
            continue;
        const before = original.slice(0, match.index);
        // "Stop" can be something to buy: a known item name standing alone in its part stays an item.
        if (known.has(normalizeIngredientName(phrase)) && PART_SEPARATOR.test(before)) {
            if (before.trim())
                return { action: null, text: original };
        }
        return { action, text: action === 'cancel' ? '' : stripTrailingFillers(before) };
    }
    return { action: null, text: original };
}
//# sourceMappingURL=detect-dictation-end.js.map